module.exports = __webpack_public_path__ + "static/media/3.82e2e217.png";